export default __webpack_public_path__ + "static/media/blog3.a5098a86.png";